/**
 * Clap PDP: personalización + presupuesto automático
 */
(function () {
  'use strict';

  const MIDDLEWARE_URL = 'https://9mscodz1lj.execute-api.us-east-1.amazonaws.com/CLAP01/calculatePrice';
  const MIDDLEWARE_API_KEY = 'Fed8bOs8z92Lds6BseaCn1TiRMpkRQDK3DaGA9O5';
  const QUOTE_URL = 'https://9mscodz1lj.execute-api.us-east-1.amazonaws.com/CLAP01/quote';
  const DEBOUNCE_MS = 450;
  const CUSTOM_QTY_DEBOUNCE_MS = 900;
  // Misma lógica que el Custom Liquid en producción
  const PERSONALIZATION_GROSS_MARKUP = 2.20;
  const VAT_FACTOR = 1.21;
  const MARKETS_GROSS_FACTOR = 1.95; // no cambiar: Markets ~61% = 1.95/1.21

  function toNetPrice(totalCost) {
    return (Math.round(Number(totalCost) * PERSONALIZATION_GROSS_MARKUP * 100) / 100) / VAT_FACTOR;
  }

  function toQuoteBase(totalCost) {
    const gross = Math.round(Number(totalCost) * PERSONALIZATION_GROSS_MARKUP * 100) / 100;
    return Number((gross / MARKETS_GROSS_FACTOR).toFixed(4));
  }

  function toMarkedNet(rawCost) {
    // rawCost de API por posición (si existiera) → neto sin IVA
    return toNetPrice(rawCost);
  }

  const COLOR_CODES = {"Surtido": "00", "Marron": "01", "Burdeos": "02", "Negro": "03", "Azul": "BL", "Rojo": "RD", "Blanco": "WH", "Gris": "07", "Amarillo": "08", "Verde": "KG", "Naranja": "OR", "Rosa Bebé": "11", "Turquesa": "12", "Beig": "13", "Plata": "14", "Gris Piedra": "15", "Plata Mate": "16", "Plata Brillo": "17", "Titanio": "18", "Champagne": "19", "Petroleo": "20", "Violeta": "21", "Transparente": "22", "Azul Transparente": "23", "Verde Transparente": "24", "Rojo Transparente": "25", "Blanco Transparente": "26", "Gris Transparente": "27", "Amarillo Transparente": "28", "Naranja Transparente": "29", "Rosa Transparente": "31", "Violeta Transparente": "32", "Blanco/negro": "33", "Blanco/gris": "34", "Blanco/rojo": "35", "Blanco/azul": "36", "Azul Royal": "RB", "Fucsia": "38", "Kaki": "39", "Madera": "40", "Chocolate": "CH", "Tierra": "EA", "Blanco Hueso": "43", "Gris Oscuro/Gris": "44", "Verde Pradera/Blanco": "47", "Lima": "LM", "Verde Militar": "49", "Fucsia Transparente": "50", "Verde Lima Transparente": "51", "Azul Claro Transparente": "52", "Marfil": "53", "Blanco/Azul Oscuro": "54", "Azul/Gris": "55", "Verde Oscuro": "60", "Cuerda": "RO", "Azul Bebé": "66", "Gris Pardo": "67", "Verde Fluorescente": "68", "Amarillo Fluorescente": "70", "Naranja Fluorescente": "71", "Fucsia Fluorescente": "72", "Verde Menta": "77", "Negro/Azul": "81", "Negro/Rojo": "83", "Blanco/Amarillo Neón": "84", "French Marino": "FN", "Blanco/Turquesa": "86", "Cobre": "90", "Beig/Rojo": "95", "Dorado Mate": "97", "Oro": "98", "Multicolor": "99", "Azul Ártico": "AA", "Abyss Blue": "AB", "Apple Green": "AG", "Azul Atolón": "AL", "Rosa Antiguo": "AP", "Aqua": "AQ", "Army": "AR", "Ceniza": "AS", "Albaricoque": "AT", "Rosa Caramelo": "AX", "Negro/Blanco": "BC", "Burgundy": "BG", "Negro/ Negro Opaco": "BK", "Negro/Lima": "BN", "Verde Botella Oscuro": "BO", "Pool Blue": "BP", "Rojo Brillante": "BT", "Azul Caribe": "CB", "Antracita Mezcla": "CE", "Creamy Green": "CI", "Chili Red": "CL", "Cream": "CM", "Rosa Crema": "CP", "Gris Carbón": "GC", "Azul Crema": "CY", "Morado Oscuro": "DA", "Negro Profundo": "DB", "Marrón Chocolate": "DC", "Deep Charcoal Grey": "DE", "Beige Obscuro": "DF", "Gris Oscuro": "DG", "Caqui Oscuro": "DK", "Denim": "DM", "Azul Pato": "DU", "Heather Light Green": "EJ", "Esmeralda": "EM", "Verde Primavera": "EO", "Verde Botella": "FG", "Fuchsia": "FU", "Marino Francés/blanco": "FW", "Verde Imperio": "GE", "Verde Golf": "GG", "Gris Jaspeado": "GM", "Frozen Green": "GN", "Dorado": "GO", "Gris Melange 2": "GY", "Heather Beige": "HB", "Denim Jaspeado": "HD", "Hibisco": "HI", "Caqui Jaspeado": "HK", "Rosa Jaspeado": "HP", "Azul Cielo Jaspeado": "HS", "Burdeos Jaspeado": "HX", "Ice Blue": "IB", "Caqui": "KH", "Limón": "LE", "Gris Claro": "LG", "Lila": "LL", "Morado Claro": "LP", "Amarillo Claro": "LY", "Metal Grey": "MG", "Medium Pink": "MP", "Gris Ratón": "MU", "Natural": "NA", "Blanco Absoluto": "NB", "Neon Coral": "NC", "Amarillo Neón": "NE", "Verde Neón": "NG", "Tilo Fluor": "NL", "Naranja Neón": "NO", "Rosa Neón 2": "NP", "Blanco/Azul Marino": "NW", "Azul Mar": "NY", "Naranja Tostado": "OB", "Rosa Orquídea": "OP", "Astral Purple": "PA", "Azul Petróleo": "PB", "Rojo Chili": "PE", "Gris Puro": "PG", "Melocotón": "PH", "Rosa": "PK", "Pop Orange": "PO", "Rosa Pálido": "PP", "Amarillo Pálido": "PY", "Negro Reciclado": "RC", "Blanco Reciclado": "RH", "Azul Marino Reciclado": "RV", "Sand": "SA", "Tilo": "SG", "Azul Cielo": "SP", "Azul Pizarra": "SL", "Rojo Tango": "TA", "Terracota": "TE", "Ultramarino": "UL", "Blanco Roto": "WW", "Zinc": "ZI"};

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /** Muestra overlay hasta JS + fuentes; evita selects grises a medias */
  function markClapPdpReady(root) {
    if (!root || root.dataset.clapReady === '1') return;
    root.dataset.clapReady = '1';
    let done = false;
    function finish() {
      if (done) return;
      done = true;
      root.classList.remove('clap-pdp-booting');
      root.classList.add('clap-pdp-ready');
      const loader = root.querySelector('.clap-pdp-loader');
      if (loader) {
        loader.setAttribute('aria-busy', 'false');
        loader.hidden = true;
      }
    }
    const fontsReady =
      document.fonts && document.fonts.ready
        ? document.fonts.ready.catch(function () {})
        : Promise.resolve();
    Promise.race([
      fontsReady,
      new Promise(function (resolve) {
        setTimeout(resolve, 1800);
      })
    ]).then(function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(finish);
      });
    });
    setTimeout(finish, 3500);
  }

  function money(n) {
    const v = Number.isFinite(n) ? n : 0;
    return v.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function parseJsonScript(id) {
    const el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('[clap] JSON inválido', id, e);
      return null;
    }
  }

  function techniqueLabel(name, map) {
    if (!name) return '';
    const key = String(name).trim().toLowerCase();
    return (map && map[key]) || name;
  }

  function positionLabel(name, map) {
    if (!name) return '';
    const raw = String(name).trim();
    // Normaliza: "SEGMENT1" → "segment 1", "LID SIDE 1" → "lid side 1"
    let key = raw
      .toLowerCase()
      .replace(/([a-z])(\d)/g, '$1 $2')
      .replace(/(\d)([a-z])/g, '$1 $2')
      .replace(/[_\-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    if (map && (map[key] || map[raw.toLowerCase()])) {
      return map[key] || map[raw.toLowerCase()];
    }

    const phraseMap = {
      // Textil
      chest: 'Pecho',
      'chest left': 'Pecho izquierdo',
      'chest right': 'Pecho derecho',
      'chest transfer': 'Pecho (transfer)',
      arm: 'Manga',
      'arm left': 'Manga izquierda',
      'arm right': 'Manga derecha',
      sleeve: 'Manga',
      'sleeve left': 'Manga izquierda',
      'sleeve right': 'Manga derecha',
      // Gafas
      leg: 'Patilla',
      'left leg': 'Patilla izquierda',
      'right leg': 'Patilla derecha',
      'leg left': 'Patilla izquierda',
      'leg right': 'Patilla derecha',
      // Botellas / 360
      roundscreen: 'Serigrafía 360',
      'round screen': 'Serigrafía 360',
      rounds: 'Serigrafía 360',
      // Generales
      front: 'Frente',
      'front pd': 'Frente PD',
      'front down': 'Frente inferior',
      'front top': 'Frente superior',
      'front pocket': 'Bolsillo frontal',
      'front td1': 'Frente TD1',
      'front td 1': 'Frente TD1',
      back: 'Dorso',
      'back pd': 'Dorso PD',
      'back down': 'Dorso inferior',
      'back top': 'Dorso superior',
      'back strap': 'Tirante trasero',
      'back transfer': 'Dorso (transfer)',
      'back td1': 'Dorso TD1',
      'back td 1': 'Dorso TD1',
      lid: 'Tapa',
      top: 'Superior',
      bottom: 'Inferior',
      strap: 'Tirante',
      embroidery: 'Bordado',
      // Técnicas como sufijo de posición
      'superior screen': 'Superior serigrafía',
      'superior debossing': 'Superior termograbado',
      'inferior screen': 'Inferior serigrafía',
      'inferior debossing': 'Inferior termograbado',
      'top screen': 'Superior serigrafía',
      'top debossing': 'Superior termograbado',
      'bottom screen': 'Inferior serigrafía',
      'bottom debossing': 'Inferior termograbado',
      // Segmentos paraguas
      'segment 1': 'Segmento 1',
      'segment 2': 'Segmento 2',
      'segment 3': 'Segmento 3',
      'segment 4': 'Segmento 4',
      // Otros
      'barrel left': 'Cuerpo izquierdo',
      'barrel right': 'Cuerpo derecho',
      'front pocket': 'Bolsillo frontal',
      'lid side 1': 'Tapa lado 1',
      'lid side 2': 'Tapa lado 2',
      'lid side 1 pad': 'Tapa lado 1 (tampografía)',
      'box 1 side 1': 'Caja 1 lado 1',
      'box 2 side 1': 'Caja 2 lado 1',
      'panel 1': 'Panel 1',
      'panel 2': 'Panel 2',
      'panel 3': 'Panel 3',
      'panel 4': 'Panel 4',
      'panel 5': 'Panel 5',
      'racket 1 screen': 'Pala 1 serigrafía',
      'racket 2 screen': 'Pala 2 serigrafía',
      'racket 1 back screen': 'Pala 1 dorso serigrafía',
      'racket 1 front pd': 'Pala 1 frente PD',
      'racket 2 back pd': 'Pala 2 dorso PD'
    };
    if (phraseMap[key]) return phraseMap[key];

    const tokenMap = {
      front: 'Frente',
      back: 'Dorso',
      chest: 'Pecho',
      arm: 'Manga',
      sleeve: 'Manga',
      leg: 'Patilla',
      left: 'izquierda',
      right: 'derecha',
      top: 'Superior',
      down: 'inferior',
      bottom: 'Inferior',
      upper: 'Superior',
      lower: 'Inferior',
      lid: 'Tapa',
      side: 'lado',
      strap: 'Tirante',
      transfer: 'transfer',
      hood: 'Capucha',
      pocket: 'Bolsillo',
      collar: 'Cuello',
      neck: 'Cuello',
      cuff: 'Puño',
      handle: 'Asa',
      body: 'Cuerpo',
      base: 'Base',
      panel: 'Panel',
      segment: 'Segmento',
      barrel: 'Cuerpo',
      box: 'Caja',
      racket: 'Pala',
      pad: 'tampografía',
      screen: 'serigrafía',
      screens: 'serigrafía',
      roundscreen: 'Serigrafía 360',
      embroidery: 'Bordado',
      debossing: 'termograbado',
      deboss: 'termograbado',
      digital: 'digital',
      laser: 'láser',
      print: 'impresión',
      printing: 'impresión',
      center: 'Centro',
      centre: 'Centro',
      middle: 'Centro',
      inside: 'Interior',
      outside: 'Exterior',
      full: 'Completo',
      half: 'Medio',
      logo: 'Logo',
      shoulder: 'Hombro',
      waist: 'Cintura',
      bag: 'Bolsa',
      bottle: 'Botella',
      cap: 'Tapa',
      cover: 'Cubierta',
      brim: 'Ala',
      visor: 'Visera',
      crown: 'Corona',
      td1: 'TD1',
      td: 'TD',
      pd: 'PD'
    };

    const parts = key.split(' ').filter(Boolean);
    if (!parts.length) return raw;

    // Orden español: "left leg" / "right arm" → cuerpo + dirección
    const dirs = { left: 1, right: 1 };
    if (parts.length === 2 && dirs[parts[0]] && tokenMap[parts[1]]) {
      const body = tokenMap[parts[1]];
      const dir = tokenMap[parts[0]];
      const label = body + ' ' + dir;
      return label.charAt(0).toUpperCase() + label.slice(1);
    }

    const translated = parts.map(function (part, idx) {
      if (tokenMap[part]) {
        const t = tokenMap[part];
        if (idx === 0 && t && t[0] === t[0].toLowerCase() && !/^\d/.test(t)) {
          return t.charAt(0).toUpperCase() + t.slice(1);
        }
        return t;
      }
      if (/^\d+$/.test(part)) return part;
      return part.charAt(0).toUpperCase() + part.slice(1);
    });
    return translated.join(' ').replace(/\s+\(/g, ' (');
  }

  const SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  const SIZE_QTY_OPTIONS = [0, 5, 10, 25, 50, 75, 100, 150, 200, 250, 500, 1000];

  const SIZE_CARET =
    '<span class="svg-wrapper">' +
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-caret" viewBox="0 0 10 6">' +
    '<path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/>' +
    '</svg>' +
    '</span>';

  /** null = sin límite de inventario; número = stock máximo vendible */
  function getVariantStockMax(variant) {
    if (!variant) return 0;
    if (!variant.inventory_management) return null;
    if (String(variant.inventory_policy || '').toLowerCase() === 'continue') return null;
    const q = Math.floor(Number(variant.inventory_quantity));
    return Number.isFinite(q) ? Math.max(0, q) : 0;
  }

  function findVariantForSize(size) {
    const sizeOpt = getSizeOptionName();
    if (!sizeOpt) return null;
    const colorOpt = getColorOptionName();
    const color = getOption(colorOpt);
    const data = getProductVariantsData();
    return (data.variants || []).find(function (v) {
      const opts = v.options || {};
      const sizeOk = String(opts[sizeOpt]) === String(size);
      const colorOk = !colorOpt || !color || String(opts[colorOpt]) === String(color);
      return sizeOk && colorOk && v.available !== false;
    }) || null;
  }

  function getSizeStockMax(size) {
    return getVariantStockMax(findVariantForSize(size));
  }

  /** Opciones de cantidad respetando stock: presets ≤ max + el máximo si no está */
  function buildSizeQtyValues(maxStock) {
    const values = [0];
    SIZE_QTY_OPTIONS.forEach(function (n) {
      if (n === 0) return;
      if (maxStock != null && n > maxStock) return;
      values.push(n);
    });
    if (maxStock != null && maxStock >= 1 && values.indexOf(maxStock) === -1) {
      values.push(maxStock);
      values.sort(function (a, b) {
        return a - b;
      });
    }
    return values;
  }

  function isAllowedSizeQty(value, maxStock) {
    const n = Math.floor(Number(value));
    if (!Number.isFinite(n) || n < 1) return false;
    if (maxStock != null && n > maxStock) return false;
    return true;
  }

  function sizeQtyOptionsHtml(selected, isOther, maxStock) {
    const values = buildSizeQtyValues(maxStock);
    let sel = isOther ? 'otro' : selected == null || selected === '' ? '0' : String(selected);
    if (!isOther && sel !== '0' && !isAllowedSizeQty(sel, maxStock)) {
      sel = maxStock != null && maxStock >= 1 ? String(maxStock) : '0';
    }
    const opts = values.map(function (n) {
      const label = n === 0 ? 'Ninguno' : String(n);
      const isSel = !isOther && String(n) === String(sel);
      return (
        '<option value="' +
        n +
        '"' +
        (isSel ? ' selected' : '') +
        '>' +
        label +
        '</option>'
      );
    });
    // "Otro" solo si hay margen entre 1 y max (o sin límite)
    const showOther = maxStock == null || maxStock > 1;
    if (showOther) {
      opts.push('<option value="otro"' + (isOther ? ' selected' : '') + '>Otro</option>');
    }
    return opts.join('');
  }

  /** Mismo markup que el dropdown de Color (Dawn .select / .select__select) */
  function sizeCellHtml(size, selectVal, isOther, customVal, maxStock) {
    const safe = String(size).replace(/"/g, '&quot;');
    const stockAttr = maxStock == null ? '' : ' data-stock-max="' + maxStock + '"';
    let safeCustom = String(customVal || '');
    if (maxStock != null && safeCustom) {
      const n = Math.floor(Number(safeCustom));
      if (!Number.isFinite(n) || n < 1 || n > maxStock) safeCustom = '';
    }
    const otherAllowed = maxStock == null || maxStock > 1;
    const useOther = Boolean(isOther && otherAllowed && safeCustom);
    const maxAttr = maxStock != null ? ' max="' + maxStock + '"' : '';
    return (
      '<div class="clap-size-cell"' +
      stockAttr +
      '>' +
      '<span class="clap-size-cell__name form__label">' +
      size +
      '</span>' +
      '<div class="select clap-size-select">' +
      '<select class="select__select clap-size-qty" data-size="' +
      safe +
      '" aria-label="Cantidad talla ' +
      safe +
      '"' +
      stockAttr +
      '>' +
      sizeQtyOptionsHtml(useOther ? '0' : selectVal, useOther, maxStock) +
      '</select>' +
      SIZE_CARET +
      '</div>' +
      '<div class="field clap-size-qty-custom-field"' +
      (useOther ? '' : ' hidden') +
      '>' +
      '<input class="field__input clap-size-qty-custom" type="number" min="1" step="1" inputmode="numeric" ' +
      maxAttr +
      ' placeholder="Ej. 80" aria-label="Cantidad personalizada talla ' +
      safe +
      '" value="' +
      safeCustom.replace(/"/g, '&quot;') +
      '">' +
      '</div>' +
      '</div>'
    );
  }

  function readSizeCellQty(cellOrSelect) {
    const cell =
      cellOrSelect && cellOrSelect.classList && cellOrSelect.classList.contains('clap-size-cell')
        ? cellOrSelect
        : cellOrSelect && cellOrSelect.closest
          ? cellOrSelect.closest('.clap-size-cell')
          : null;
    if (!cell) return 0;
    const select = cell.querySelector('.clap-size-qty');
    if (!select) return 0;
    const maxRaw = cell.getAttribute('data-stock-max');
    const maxStock = maxRaw != null && maxRaw !== '' ? Math.floor(Number(maxRaw)) : null;
    let qty = 0;
    if (select.value === 'otro') {
      const custom = cell.querySelector('.clap-size-qty-custom');
      const n = Math.floor(Number(custom && custom.value));
      qty = Number.isFinite(n) && n >= 1 ? n : 0;
    } else {
      const n = Math.floor(Number(select.value));
      qty = Number.isFinite(n) && n >= 1 ? n : 0;
    }
    if (maxStock != null && Number.isFinite(maxStock) && qty > maxStock) return maxStock;
    return qty;
  }

  function getProductVariantsData() {
    return parseJsonScript('clap-product-variants') || { options: [], variants: [] };
  }

  function findOptionName(options, candidates) {
    const list = options || [];
    for (let i = 0; i < candidates.length; i++) {
      const want = candidates[i].toLowerCase();
      for (let j = 0; j < list.length; j++) {
        if (String(list[j]).toLowerCase() === want) return list[j];
      }
    }
    return null;
  }

  function getSizeOptionName() {
    const data = getProductVariantsData();
    return findOptionName(data.options, ['talla', 'size', 'tallas', 'sizes', 'taille']);
  }

  function getColorOptionName() {
    const data = getProductVariantsData();
    return findOptionName(data.options, ['color', 'colour', 'couleur']) || 'Color';
  }

  function isSizeMatrixProduct() {
    return Boolean(getSizeOptionName());
  }

  function sortSizes(sizes) {
    return sizes.slice().sort(function (a, b) {
      const ia = SIZE_ORDER.indexOf(String(a).toUpperCase());
      const ib = SIZE_ORDER.indexOf(String(b).toUpperCase());
      if (ia === -1 && ib === -1) return String(a).localeCompare(String(b), 'es');
      if (ia === -1) return 1;
      if (ib === -1) return -1;
      return ia - ib;
    });
  }

  function getOption(name) {
    if (!name) return null;
    const sel = document.querySelector('select[name="options[' + name + ']"]');
    if (sel) return sel.value;
    const checked = document.querySelector('input[name="options[' + name + ']"]:checked');
    return checked ? checked.value : null;
  }

  /** Líneas talla → cantidad (solo las > 0) */
  function getSizeLines() {
    const sizeOpt = getSizeOptionName();
    if (!sizeOpt) return [];
    const colorOpt = getColorOptionName();
    const color = getOption(colorOpt);
    const data = getProductVariantsData();
    const cells = document.querySelectorAll('.clap-size-cell');
    const lines = [];
    cells.forEach(function (cell) {
      const select = cell.querySelector('.clap-size-qty[data-size]');
      if (!select) return;
      const qty = readSizeCellQty(cell);
      if (qty < 1) return;
      const size = select.getAttribute('data-size');
      const variant = (data.variants || []).find(function (v) {
        const opts = v.options || {};
        const sizeOk = String(opts[sizeOpt]) === String(size);
        const colorOk = !colorOpt || !color || String(opts[colorOpt]) === String(color);
        return sizeOk && colorOk && v.available !== false;
      });
      if (!variant) return;
      lines.push({
        size: size,
        quantity: qty,
        variantId: String(variant.id),
        price: Number(variant.price) || 0,
        sku: variant.sku || ''
      });
    });
    return lines;
  }

  function getSizeBreakdownLabel() {
    return getSizeLines()
      .map(function (l) {
        return l.quantity + '×' + l.size;
      })
      .join(', ');
  }

  function getQty() {
    if (isSizeMatrixProduct() && document.querySelector('.clap-size-matrix')) {
      const lines = getSizeLines();
      const total = lines.reduce(function (s, l) {
        return s + l.quantity;
      }, 0);
      return total >= 1 ? total : null;
    }
    const select = document.getElementById('clap-qty-select');
    const custom = document.getElementById('clap-qty-custom');
    if (select) {
      if (select.value === 'otro') {
        const n = Math.floor(Number(custom && custom.value));
        return Number.isFinite(n) && n >= 1 ? n : null;
      }
      const n = Math.floor(Number(select.value));
      return Number.isFinite(n) && n >= 1 ? n : 1;
    }
    const input = document.querySelector('input[name="quantity"]');
    const n = Math.floor(Number(input && input.value));
    return Number.isFinite(n) && n >= 1 ? n : 1;
  }

  function syncNativeQty(n) {
    if (n == null) return;
    const inputs = document.querySelectorAll(
      'input[name="quantity"], .quantity__input[name="quantity"], input.quantity__input'
    );
    inputs.forEach(function (input) {
      input.value = String(n);
      input.setAttribute('value', String(n));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  function getVariantId(quote) {
    const lines = isSizeMatrixProduct() ? getSizeLines() : [];
    if (lines.length) return lines[0].variantId;
    const candidates = [
      document.querySelector('product-form form [name="id"]'),
      document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]'),
      document.querySelector('.product-variant-id'),
      document.querySelector('input.product-variant-id')
    ];
    for (let i = 0; i < candidates.length; i++) {
      const el = candidates[i];
      if (el && el.value) return String(el.value);
    }
    if (quote && quote.dataset.variantId) return String(quote.dataset.variantId);
    const analytic = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId;
    return analytic ? String(analytic) : null;
  }

  function getUnitPriceCents(quote) {
    const lines = isSizeMatrixProduct() ? getSizeLines() : [];
    if (lines.length) return lines[0].price;
    const cents = Number(quote.dataset.unitPrice);
    return Number.isFinite(cents) ? cents : 0;
  }

  /** Total producto en € (suma líneas de talla o precio unitario × qty) */
  function getProductTotalEuros(quote) {
    const lines = isSizeMatrixProduct() ? getSizeLines() : [];
    if (lines.length) {
      return lines.reduce(function (s, l) {
        return s + (l.price * l.quantity) / 100;
      }, 0);
    }
    const units = getQty() || 0;
    return (getUnitPriceCents(quote) * Math.max(units, 1)) / 100;
  }

  /** Notifica cambio de cantidad (matriz o dropdown) al panel de presupuesto */
  function notifyQtyChange() {
    document.dispatchEvent(new CustomEvent('clap:qty-change'));
  }

  /** Append product line(s) to FormData; returns next item index */
  function appendProductLines(formData, startIndex, props) {
    const lines = isSizeMatrixProduct() ? getSizeLines() : [];
    let idx = startIndex;
    if (lines.length) {
      const breakdown = getSizeBreakdownLabel();
      lines.forEach(function (line) {
        formData.append('items[' + idx + '][id]', line.variantId);
        formData.append('items[' + idx + '][quantity]', String(line.quantity));
        if (props) {
          Object.keys(props).forEach(function (key) {
            formData.append('items[' + idx + '][properties][' + key + ']', props[key]);
          });
        }
        if (breakdown && !(props && props['Desglose tallas'])) {
          formData.append('items[' + idx + '][properties][Desglose tallas]', breakdown);
        }
        idx++;
      });
      return idx;
    }
    const variantId = getVariantId();
    const units = getQty() || 1;
    formData.append('items[' + idx + '][id]', variantId);
    formData.append('items[' + idx + '][quantity]', String(units));
    if (props) {
      Object.keys(props).forEach(function (key) {
        formData.append('items[' + idx + '][properties][' + key + ']', props[key]);
      });
    }
    return idx + 1;
  }

  ready(function initClapPdp() {
    const productRoot = document.querySelector('.product--clap-pdp');
    if (!productRoot) return;

    function layoutPdp() {
      const info = productRoot.querySelector('.product__info-container') || productRoot;

      // Meta inline: SKU + stock
      const sku = info.querySelector('.product__sku');
      const inventory = info.querySelector('.product__inventory');
      if (sku && !info.querySelector('.clap-meta-inline')) {
        const meta = document.createElement('div');
        meta.className = 'clap-meta-inline';
        sku.parentNode.insertBefore(meta, sku);
        meta.appendChild(sku);
        if (inventory) meta.appendChild(inventory);
      } else if (inventory && info.querySelector('.clap-meta-inline') && !inventory.closest('.clap-meta-inline')) {
        info.querySelector('.clap-meta-inline').appendChild(inventory);
      }

      // Controles en una fila: color + cantidad + logo
      if (!info.querySelector('.clap-controls')) {
        const row = document.createElement('div');
        row.className = 'clap-controls';

        const variant =
          info.querySelector('variant-selects') ||
          info.querySelector('.product-form__input--dropdown') ||
          info.querySelector('[id^="Variant-"]') ||
          info.querySelector('.product-form__input:has(select[name^="options"])');
        const qty = info.querySelector('[id^="Quantity-Form-"]');
        const fileWrap =
          info.querySelector('#file-añade') &&
          info.querySelector('#file-añade').closest('.product-form__input');

        const anchor = qty || variant || fileWrap;
        if (anchor) {
          anchor.parentNode.insertBefore(row, anchor);
          if (variant) row.appendChild(variant.closest('.product-form__input') || variant);
          if (qty) row.appendChild(qty);
          if (fileWrap) {
            fileWrap.classList.add('clap-logo-field');
            row.appendChild(fileWrap);
          }
        }
      }

      if (isSizeMatrixProduct()) {
        setupSizeMatrix(info);
      } else {
        setupQtyDropdown(info);
      }

      // Logo → botón icono + etiqueta clara
      const uploadBtn = document.getElementById('button-añade');
      const fileInput = document.getElementById('file-añade');
      const fileNameDisplay = document.getElementById('fileName-añade');
      const logoLabel = info.querySelector('label.form__label[for="file-añade"]');
      if (logoLabel) logoLabel.textContent = 'Subir logo - Recibirás boceto';
      // Ocultar el párrafo largo antiguo ("Sube tu logo…")
      const logoField =
        (fileInput && fileInput.closest('.product-form__input')) ||
        info.querySelector('.clap-logo-field');
      if (logoField) {
        Array.from(logoField.querySelectorAll(':scope > p')).forEach(function (p) {
          if (p.id === 'fileName-añade' || p.id === 'uploadErrorEl' || p.classList.contains('clap-logo-note')) {
            return;
          }
          if (/sube tu logo|info@clapcomunicacion/i.test(p.textContent || '')) {
            p.hidden = true;
          }
        });
      }
      if (uploadBtn && fileInput && !uploadBtn.dataset.clapIcon) {
        uploadBtn.dataset.clapIcon = '1';
        uploadBtn.className = 'clap-upload';
        uploadBtn.type = 'button';
        uploadBtn.setAttribute('aria-label', 'Subir logo - Recibirás boceto');
        uploadBtn.title = 'Subir logo - Recibirás boceto';
        uploadBtn.innerHTML =
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 16V5"/><path d="M8 9l4-4 4 4"/><path d="M5 16.5V18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1.5"/></svg>';

        let note = info.querySelector('.clap-logo-note');
        if (!note) {
          note = document.createElement('p');
          note.className = 'clap-logo-note';
          note.textContent = 'Subir logo - Recibirás boceto';
          const field = fileInput.closest('.clap-logo-field') || fileInput.closest('.product-form__input');
          if (field) field.appendChild(note);
        }

        const syncLogo = function () {
          const file = fileInput.files && fileInput.files[0];
          uploadBtn.classList.toggle('has-file', Boolean(file));
          if (note) {
            note.textContent = file
              ? file.name + ' - Recibirás boceto'
              : 'Subir logo - Recibirás boceto';
          }
          if (logoLabel && !file) {
            logoLabel.textContent = 'Subir logo - Recibirás boceto';
          }
          if (fileNameDisplay) fileNameDisplay.textContent = file ? file.name : '';
        };
        fileInput.addEventListener('change', syncLogo);
        syncLogo();
      }

      // Nota de entrega → debajo de controles
      const controls = info.querySelector('.clap-controls');
      const deliverySource =
        info.querySelector('.clap-delivery-source') ||
        Array.from(info.querySelectorAll('strong, p')).find(function (el) {
          return /Productos sin personalizar/i.test(el.textContent || '');
        });
      if (deliverySource && controls && !info.querySelector('.clap-delivery-note')) {
        const note = document.createElement('p');
        note.className = 'clap-delivery-note';
        note.textContent = (deliverySource.textContent || '').replace(/\s+/g, ' ').trim();
        if (deliverySource.parentNode) deliverySource.parentNode.removeChild(deliverySource);
        controls.insertAdjacentElement('afterend', note);
      }
      // Descripción colapsable
      const desc = productRoot.querySelector('.product__description');
      if (desc && !desc.dataset.clapClamp) {
        desc.dataset.clapClamp = '1';
        desc.classList.add('clap-desc-clamped');
        const more = document.createElement('button');
        more.type = 'button';
        more.className = 'clap-desc-more';
        more.textContent = 'Ver descripción';
        more.setAttribute('aria-expanded', 'false');
        more.addEventListener('click', function () {
          const open = desc.classList.toggle('clap-desc-clamped') === false;
          more.textContent = open ? 'Ocultar descripción' : 'Ver descripción';
          more.setAttribute('aria-expanded', String(open));
        });
        desc.insertAdjacentElement('afterend', more);
      }
    }

    function hideNativeSizeOption(info) {
      const sizeOpt = getSizeOptionName();
      if (!sizeOpt) return;
      const selects = info.querySelectorAll('variant-selects .product-form__input, .product-form__input');
      selects.forEach(function (wrap) {
        const label = wrap.querySelector('.form__label, legend');
        const sel = wrap.querySelector('select[name^="options"]');
        const name = (label && label.textContent) || (sel && sel.getAttribute('name')) || '';
        if (new RegExp(sizeOpt, 'i').test(name) || (sel && sel.name === 'options[' + sizeOpt + ']')) {
          wrap.hidden = true;
          wrap.classList.add('clap-size-native-hidden');
        }
      });
    }

    function setupSizeMatrix(info) {
      const sizeOpt = getSizeOptionName();
      if (!sizeOpt) return;
      hideNativeSizeOption(info);

      const qtyForm = info.querySelector('[id^="Quantity-Form-"]');
      if (!qtyForm) return;
      qtyForm.dataset.clapQty = 'matrix';
      qtyForm.classList.add('clap-qty-wrap', 'clap-qty-wrap--matrix', 'clap-qty-ready');

      const native = qtyForm.querySelector('quantity-input');
      if (native) native.setAttribute('hidden', '');

      function onSizeQtyChange() {
        const total = getQty();
        syncNativeQty(total || 0);
        notifyQtyChange();
      }

      function wireSizeGrid(grid) {
        if (!grid || grid.dataset.clapWired === '1') return;
        grid.dataset.clapWired = '1';
        grid.querySelectorAll('.clap-size-qty').forEach(function (sel) {
          sel.addEventListener('change', function () {
            const cell = sel.closest('.clap-size-cell');
            const custom = cell && cell.querySelector('.clap-size-qty-custom');
            const customField = cell && cell.querySelector('.clap-size-qty-custom-field');
            if (!custom) return;
            const isOther = sel.value === 'otro';
            custom.hidden = !isOther;
            if (customField) customField.hidden = !isOther;
            if (isOther) custom.focus();
            else custom.value = '';
            onSizeQtyChange();
          });
        });
        grid.querySelectorAll('.clap-size-qty-custom').forEach(function (inp) {
          let timer = null;
          function clampCustom() {
            const cell = inp.closest('.clap-size-cell');
            const maxRaw = cell && cell.getAttribute('data-stock-max');
            if (maxRaw == null || maxRaw === '') return;
            const maxStock = Math.floor(Number(maxRaw));
            const n = Math.floor(Number(inp.value));
            if (!Number.isFinite(maxStock)) return;
            if (Number.isFinite(n) && n > maxStock) inp.value = String(maxStock);
          }
          inp.addEventListener('input', function () {
            clampCustom();
            clearTimeout(timer);
            timer = setTimeout(onSizeQtyChange, CUSTOM_QTY_DEBOUNCE_MS);
          });
          inp.addEventListener('change', function () {
            clampCustom();
            onSizeQtyChange();
          });
        });
      }

      function cellsHtml(sizes, prev) {
        return sizes
          .map(function (size) {
            const maxStock = getSizeStockMax(size);
            const saved = prev[size];
            let isOther = saved && saved.mode === 'otro';
            let selectVal = saved ? saved.value : '0';
            let customVal = '';
            if (saved && saved.mode === 'otro') {
              customVal = saved.value || '';
            } else if (saved && saved.value && Number(saved.value) >= 1) {
              const allowed = buildSizeQtyValues(maxStock);
              if (allowed.indexOf(Math.floor(Number(saved.value))) === -1) {
                isOther = true;
                customVal = saved.value;
              }
            }
            if (selectVal !== '0' && selectVal !== 'otro' && !isAllowedSizeQty(selectVal, maxStock)) {
              selectVal = maxStock != null && maxStock >= 1 ? String(maxStock) : '0';
              isOther = false;
              customVal = '';
            }
            if (customVal && !isAllowedSizeQty(customVal, maxStock)) {
              if (maxStock != null && maxStock >= 1) {
                isOther = false;
                selectVal = String(maxStock);
                customVal = '';
              } else {
                isOther = false;
                selectVal = '0';
                customVal = '';
              }
            }
            return sizeCellHtml(size, isOther ? '0' : selectVal, isOther, customVal, maxStock);
          })
          .join('');
      }

      function collectPrev(grid) {
        const prev = {};
        if (!grid) return prev;
        grid.querySelectorAll('.clap-size-cell').forEach(function (cell) {
          const sel = cell.querySelector('.clap-size-qty');
          if (!sel) return;
          const size = sel.getAttribute('data-size');
          const qty = readSizeCellQty(cell);
          prev[size] = {
            mode: sel.value === 'otro' ? 'otro' : 'preset',
            value: sel.value === 'otro' ? String(qty || '') : sel.value
          };
        });
        return prev;
      }

      function availableSizes() {
        const colorOpt = getColorOptionName();
        const color = getOption(colorOpt);
        const data = getProductVariantsData();
        const sizeSet = {};
        (data.variants || []).forEach(function (v) {
          const opts = v.options || {};
          if (colorOpt && color && String(opts[colorOpt]) !== String(color)) return;
          if (v.available === false) return;
          const s = opts[sizeOpt];
          if (s) sizeSet[s] = true;
        });
        return sortSizes(Object.keys(sizeSet));
      }

      function renderSizeGrid() {
        const grid = document.getElementById('clap-size-grid');
        if (!grid) return;
        const prev = collectPrev(grid);
        const sizes = availableSizes();
        if (!sizes.length) {
          grid.dataset.clapWired = '';
          grid.innerHTML = '<p class="clap-size-matrix__empty">No hay tallas disponibles para este color.</p>';
          syncNativeQty(0);
          onSizeQtyChange();
          return;
        }
        // Sustituir de un golpe (evita frame con <select> vacío)
        grid.dataset.clapWired = '';
        grid.innerHTML = cellsHtml(sizes, prev);
        wireSizeGrid(grid);
        onSizeQtyChange();
      }

      let matrix = qtyForm.querySelector('.clap-size-matrix');
      if (!matrix) {
        const wrap = document.createElement('div');
        wrap.className = 'clap-size-matrix';
        wrap.innerHTML =
          '<p class="clap-size-matrix__label form__label">Cantidad por talla</p>' +
          '<div class="clap-size-matrix__grid" id="clap-size-grid"></div>' +
          '<p class="clap-size-matrix__hint">Elige unidades por talla, Ninguno u Otro. El total se suma automáticamente.</p>';
        qtyForm.appendChild(wrap);
      }
      // Siempre regenerar opciones según stock del color actual
      renderSizeGrid();

      if (!qtyForm.dataset.clapSizeWired) {
        qtyForm.dataset.clapSizeWired = '1';
        let lastColor = getOption(getColorOptionName());
        info.addEventListener('change', function (event) {
          const t = event.target;
          if (!t || !t.name) return;
          const colorOpt = getColorOptionName();
          if (t.name !== 'options[' + colorOpt + ']') return;
          const next = getOption(colorOpt);
          if (String(next) === String(lastColor)) return;
          lastColor = next;
          renderSizeGrid();
        });
      }
    }

    function setupQtyDropdown(info) {
      const qtyForm = info.querySelector('[id^="Quantity-Form-"]');
      if (!qtyForm || qtyForm.dataset.clapQty === '1' || qtyForm.dataset.clapQty === 'matrix') return;
      qtyForm.dataset.clapQty = '1';
      qtyForm.classList.add('clap-qty-wrap');

      const native = qtyForm.querySelector('quantity-input');
      if (native) native.setAttribute('hidden', '');

      const field = document.createElement('div');
      field.className = 'clap-qty-field';
      field.innerHTML =
        '<div class="clap-qty-row">' +
        '<div class="product-form__input product-form__input--dropdown clap-qty-select-block">' +
        '<label class="form__label" for="clap-qty-select">Cantidad</label>' +
        '<div class="select">' +
        '<select id="clap-qty-select" class="select__select">' +
        '<option value="50">50</option>' +
        '<option value="100" selected>100</option>' +
        '<option value="500">500</option>' +
        '<option value="1000">1.000</option>' +
        '<option value="otro">Otro</option>' +
        '</select>' +
        '<span class="svg-wrapper">' +
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-caret" viewBox="0 0 10 6">' +
        '<path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/>' +
        '</svg>' +
        '</span>' +
        '</div>' +
        '</div>' +
        '<div class="product-form__input clap-qty-custom-wrap" hidden>' +
        '<label class="form__label" for="clap-qty-custom">Escribe la cantidad</label>' +
        '<div class="field">' +
        '<input id="clap-qty-custom" class="field__input" type="number" min="1" inputmode="numeric" placeholder="Ej. 250" autocomplete="off">' +
        '</div>' +
        '</div>' +
        '</div>';
      qtyForm.appendChild(field);
      qtyForm.classList.add('clap-qty-ready');

      const select = field.querySelector('#clap-qty-select');
      const custom = field.querySelector('#clap-qty-custom');
      const customWrap = field.querySelector('.clap-qty-custom-wrap');
      let customTimer = null;

      syncNativeQty(100);

      select.addEventListener('change', function () {
        clearTimeout(customTimer);
        const isOther = select.value === 'otro';
        if (customWrap) customWrap.hidden = !isOther;
        if (custom) custom.hidden = !isOther;
        if (isOther) {
          custom.focus();
          return;
        }
        syncNativeQty(Number(select.value));
        notifyQtyChange();
      });

      custom.addEventListener('input', function () {
        clearTimeout(customTimer);
        const n = Math.floor(Number(custom.value));
        if (Number.isFinite(n) && n >= 1) syncNativeQty(n);
        // No recalcular hasta que el usuario deje de escribir
        customTimer = setTimeout(function () {
          const qty = getQty();
          if (qty == null) return;
          notifyQtyChange();
        }, CUSTOM_QTY_DEBOUNCE_MS);
      });
    }


    layoutPdp();

    const perso = document.getElementById('clap-perso');
    const quote = document.getElementById('clap-quote');
    const productData = parseJsonScript('clap-product-print-data');
    const labelMap = parseJsonScript('clap-technique-labels') || {};
    const positionMap = parseJsonScript('clap-position-labels') || {};
    const hasPrint =
      perso &&
      quote &&
      productData &&
      Array.isArray(productData.printing_positions) &&
      productData.printing_positions.length;

    // Productos sin personalización: mismo panel derecho + dropdown, sin API
    if (!hasPrint) {
      if (!quote) {
        markClapPdpReady(productRoot);
        return;
      }
      const addBtnSimple = document.getElementById('clap-add-to-cart');
      const vatSimple = Number(quote.dataset.vat) || VAT_FACTOR;

      function renderSimpleQuote() {
        const units = getQty();
        const hasQty = units != null && units >= 1;
        const productTotal = hasQty ? getProductTotalEuros(quote) : 0;
        const displayUnits = hasQty ? units : 1;
        const withVat = productTotal * vatSimple;
        const each = hasQty ? productTotal / displayUnits : 0;

        const set = function (id, text) {
          const el = document.getElementById(id);
          if (el) el.textContent = text;
        };
        set('clap-q-units', hasQty ? String(units) : '—');
        set('clap-q-product', hasQty ? money(productTotal) : '—');
        set('clap-q-total', hasQty ? money(productTotal) : '—');
        set('clap-q-each', hasQty ? money(each) : '—');
        set('clap-q-vat', hasQty ? money(withVat) : '—');
        set('clap-q-product-name', quote.dataset.productTitle || '');
        const breakdown = getSizeBreakdownLabel();
        const color = getOption(getColorOptionName());
        set(
          'clap-q-variant',
          hasQty
            ? [breakdown || quote.dataset.productSku || '', color].filter(Boolean).join(' · ')
            : color || ''
        );

        const prints = document.getElementById('clap-q-prints');
        if (prints) {
          prints.innerHTML =
            '<div class="clap-quote__line"><div><div>Personalización</div>' +
            '<div class="clap-quote__sub">Sin personalización</div></div><b>0,00 €</b></div>';
        }

        if (addBtnSimple) addBtnSimple.disabled = !hasQty;
      }

      function wireSimpleQty() {
        const select = document.getElementById('clap-qty-select');
        const custom = document.getElementById('clap-qty-custom');
        if (select) {
          select.addEventListener('change', function () {
            const q = getQty();
            if (q != null) syncNativeQty(q);
            renderSimpleQuote();
          });
        }
        if (custom) {
          custom.addEventListener('input', function () {
            const q = getQty();
            if (q != null) syncNativeQty(q);
            renderSimpleQuote();
          });
        }
        document.addEventListener('clap:qty-change', renderSimpleQuote);
      }

      if (addBtnSimple) {
        addBtnSimple.addEventListener('click', async function () {
          const units = getQty();
          if (units == null) {
            alert(
              isSizeMatrixProduct()
                ? 'Indica la cantidad en al menos una talla.'
                : 'Indica una cantidad válida.'
            );
            return;
          }
          syncNativeQty(units);

          if (!isSizeMatrixProduct()) {
            const variantId = getVariantId(quote);
            if (!variantId) {
              alert('No se ha podido detectar la variante seleccionada.');
              return;
            }
          } else if (!getSizeLines().length) {
            alert('Indica la cantidad en al menos una talla.');
            return;
          }

          addBtnSimple.disabled = true;
          const prevLabel = addBtnSimple.textContent;
          addBtnSimple.textContent = 'Procesando…';

          try {
            const formData = new FormData();
            appendProductLines(formData, 0, null);

            const fileInputs = document.querySelectorAll("input[type='file'][name^='properties']");
            let fileIndex = 1;
            fileInputs.forEach(function (input) {
              if (input.files && input.files.length) {
                for (let i = 0; i < input.files.length; i++) {
                  // Adjuntar archivos a la primera línea
                  formData.append('items[0][properties][Archivo ' + fileIndex + ']', input.files[i]);
                  fileIndex++;
                }
              }
            });

            const cartEl =
              document.querySelector('cart-drawer') || document.querySelector('cart-notification');
            if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
              formData.append(
                'sections',
                cartEl
                  .getSectionsToRender()
                  .map(function (section) {
                    return section.id;
                  })
                  .join(',')
              );
              formData.append('sections_url', window.location.pathname);
            }

            const cartUrl =
              (window.routes && window.routes.cart_add_url) || '/cart/add.js';
            const cartRes = await fetch(cartUrl, {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/javascript'
              },
              body: formData
            });
            const cartData = await cartRes.json().catch(function () {
              return null;
            });

            if (!cartRes.ok || !cartData || cartData.status) {
              alert(
                (cartData && (cartData.description || cartData.message)) ||
                  'No se pudo añadir al carrito.'
              );
              return;
            }

            try {
              if (cartEl && typeof cartEl.renderContents === 'function' && cartData.sections) {
                cartEl.renderContents(cartData);
              }
            } catch (e) {}

            try {
              const bubbleRes = await fetch(
                ((window.routes && window.routes.cart_url) || '/cart') +
                  '?section_id=cart-icon-bubble'
              );
              const bubbleDoc = new DOMParser().parseFromString(
                await bubbleRes.text(),
                'text/html'
              );
              const bubbleSection = bubbleDoc.querySelector('.shopify-section');
              const bubbleTarget = document.getElementById('cart-icon-bubble');
              if (bubbleSection && bubbleTarget) {
                bubbleTarget.innerHTML = bubbleSection.innerHTML;
              }
              const cartJs = await fetch('/cart.js').then(function (r) {
                return r.json();
              });
              if (typeof window.__clapPaintCartBubble === 'function') {
                window.__clapPaintCartBubble(cartJs);
              }
            } catch (e2) {}

            if (cartEl && typeof cartEl.open === 'function') cartEl.open();
          } catch (err) {
            console.error('[clap] add simple', err);
            alert('No se pudo añadir al carrito.');
          } finally {
            addBtnSimple.disabled = false;
            addBtnSimple.textContent = prevLabel || 'Agregar al carrito';
            renderSimpleQuote();
          }
        });
      }

      wireSimpleQty();
      renderSimpleQuote();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          try {
            const variant = event && event.data && event.data.variant;
            if (variant) {
              if (variant.id) quote.dataset.variantId = String(variant.id);
              if (variant.price != null) quote.dataset.unitPrice = String(variant.price);
              if (variant.sku) quote.dataset.productSku = variant.sku;
            }
          } catch (e) {}
          renderSimpleQuote();
        });
      }
      markClapPdpReady(productRoot);
      return;
    }

    const posBox = document.getElementById('clap-positions');
    const techBox = document.getElementById('clap-tech');
    const loadingEl = document.getElementById('clap-quote-loading');
    const errorEl = document.getElementById('clap-quote-error');
    const addBtn = document.getElementById('clap-add-to-cart');
    const printsEl = document.getElementById('clap-q-prints');

    const selections = {};
    let latestTotalCost = null;
    let latestApiData = null;
    let latestPrintTotal = 0;
    let calcToken = 0;
    let debounceTimer = null;
    let calculating = false;

    const vat = Number(quote.dataset.vat) || VAT_FACTOR;

    function sortTechniques(list) {
      return (list || []).slice().sort(function (a, b) {
        return String(a.name || '').localeCompare(String(b.name || ''), 'es', { sensitivity: 'base' });
      });
    }

    function updatePositionImages(colorCode) {
      posBox.querySelectorAll('.clap-pos').forEach(function (btn) {
        let images = [];
        try {
          images = JSON.parse(btn.getAttribute('data-images') || '[]');
        } catch (e) {}
        const img = btn.querySelector('img');
        if (!img || !images.length) return;
        const match = images.find(function (image) {
          return image.variant_color === colorCode;
        });
        const src =
          (match && match.print_position_image_with_area) ||
          images[0].print_position_image_with_area ||
          '';
        if (src) img.src = src;
      });
    }

    function renderPositions() {
      posBox.innerHTML = '';
      productData.printing_positions.forEach(function (position) {
        const id = position.position_id;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'clap-pos';
        btn.setAttribute('data-position-id', id);
        btn.setAttribute('data-images', JSON.stringify(position.images || []));
        btn.setAttribute('aria-pressed', String(Boolean(selections[id])));
        const label = positionLabel(id, positionMap);
        btn.innerHTML =
          '<img class="clap-pos__img" alt="Posición ' +
          label.replace(/"/g, '') +
          '" width="120" height="120" loading="lazy"><span class="clap-pos__name"></span>';
        btn.querySelector('.clap-pos__name').textContent = label;
        btn.addEventListener('click', function () {
          if (calculating) return;
          if (selections[id]) {
            delete selections[id];
          } else {
            const techniques = sortTechniques(position.printing_techniques);
            const first = techniques[0];
            selections[id] = {
              tech: first ? first.name : null,
              techId: first ? first.id : null,
              colors: 1,
              maxColours: first ? Number(first.max_colours) || 1 : 1
            };
          }
          renderPositions();
          renderTech();
          scheduleCalculate();
        });
        posBox.appendChild(btn);
      });

      const colorName = getOption('Color');
      const code = (colorName && COLOR_CODES[colorName]) || null;
      updatePositionImages(code);
    }

    function chosenList() {
      return productData.printing_positions
        .filter(function (p) {
          return selections[p.position_id];
        })
        .map(function (p) {
          return Object.assign({ pos: p }, selections[p.position_id]);
        });
    }

    function renderTech() {
      const chosen = chosenList();
      techBox.innerHTML = '';
      if (!chosen.length) {
        techBox.hidden = true;
        syncSelectedJson();
        return;
      }
      techBox.hidden = false;

      chosen.forEach(function (item) {
        const pos = item.pos;
        const techniques = sortTechniques(pos.printing_techniques);
        const only = techniques.length === 1;
        const group = document.createElement('div');
        group.className = 'clap-tech-group';

        const kicker = document.createElement('div');
        kicker.className = 'clap-tech-kicker';
        kicker.textContent = positionLabel(pos.position_id, positionMap);
        group.appendChild(kicker);

        const tabs = document.createElement('div');
        tabs.className = 'clap-tech-tabs';
        tabs.setAttribute('role', 'radiogroup');
        tabs.setAttribute('aria-label', 'Técnica de ' + positionLabel(pos.position_id, positionMap));

        techniques.forEach(function (tech) {
          const b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-pressed', String(only || tech.name === item.tech));
          b.textContent = techniqueLabel(tech.name, labelMap);
          if (only) b.classList.add('is-only');
          else {
            b.addEventListener('click', function () {
              if (calculating) return;
              if (selections[pos.position_id].tech === tech.name) {
                selections[pos.position_id].tech = null;
                selections[pos.position_id].techId = null;
                selections[pos.position_id].colors = 1;
                selections[pos.position_id].maxColours = 1;
              } else {
                selections[pos.position_id].tech = tech.name;
                selections[pos.position_id].techId = tech.id;
                selections[pos.position_id].maxColours = Number(tech.max_colours) || 1;
                selections[pos.position_id].colors = 1;
              }
              renderTech();
              scheduleCalculate();
            });
          }
          tabs.appendChild(b);
        });
        group.appendChild(tabs);

        const maxC = Number(item.maxColours) || 1;
        if (item.tech && maxC > 1) {
          const row = document.createElement('div');
          row.className = 'clap-colors';
          row.setAttribute('role', 'radiogroup');
          row.setAttribute('aria-label', 'Número de colores de ' + positionLabel(pos.position_id, positionMap));
          const label = document.createElement('span');
          label.textContent = 'Colores';
          row.appendChild(label);
          for (let n = 1; n <= maxC; n++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('role', 'radio');
            b.textContent = String(n);
            b.setAttribute('aria-label', n + (n === 1 ? ' color' : ' colores'));
            b.setAttribute('aria-pressed', String(n === item.colors));
            b.addEventListener('click', function () {
              if (calculating) return;
              selections[pos.position_id].colors = n;
              renderTech();
              scheduleCalculate();
            });
            row.appendChild(b);
          }
          group.appendChild(row);
        }

        techBox.appendChild(group);
      });

      syncSelectedJson();
    }

    function buildRequestData() {
      const sizeLabel = getSizeBreakdownLabel() || getOption(getSizeOptionName() || 'Talla');
      const data = {
        quantity: String(getQty() || 0),
        color: getOption(getColorOptionName() || 'Color'),
        size: sizeLabel || getOption('Talla'),
        print_manipulation: productData.print_manipulation,
        printing_positions: []
      };

      chosenList().forEach(function (item) {
        if (!item.tech) return;
        data.printing_positions.push({
          position_id: item.pos.position_id,
          printing_technique: {
            id: item.techId,
            name: item.tech,
            colors: item.colors || 1
          }
        });
      });
      return data;
    }

    function syncSelectedJson() {
      const data = buildRequestData();
      const jsonEl = document.getElementById('selecteDataJson');
      if (jsonEl) jsonEl.textContent = JSON.stringify(data, null, 2);

      const display = document.getElementById('selectedDataDisplay');
      if (display) {
        let html = '';
        if (data.quantity) html += '<p><strong>Cantidad :</strong> ' + data.quantity + '</p>';
        if (data.color) html += '<p><strong>Color :</strong> ' + data.color + '</p>';
        if (data.size) html += '<p><strong>Talla :</strong> ' + data.size + '</p>';
        data.printing_positions.forEach(function (position) {
          html +=
            '<p><strong>Posición:</strong> ' +
            positionLabel(position.position_id, positionMap) +
            '</p>';
          const technique = techniqueLabel(position.printing_technique.name, labelMap);
          const numColors = position.printing_technique.colors;
          const colorLabel = numColors === 1 ? 'color' : 'colores';
          html += '<p>- ' + technique + ' (' + numColors + ' ' + colorLabel + ')</p>';
        });
        display.innerHTML = html;
      }

      const emailComment = document.getElementById('CustomizeIt-body');
      if (emailComment) {
        let text = '';
        if (data.quantity) text += 'Cantidad: ' + data.quantity + '\n';
        if (data.color) text += 'Color: ' + data.color + '\n';
        if (data.size) text += 'Talla: ' + data.size + '\n';
        if (data.printing_positions.length) text += '\n';
        data.printing_positions.forEach(function (position) {
          text += 'Posición: ' + positionLabel(position.position_id, positionMap) + '\n';
          const technique = techniqueLabel(position.printing_technique.name, labelMap);
          const numColors = position.printing_technique.colors;
          const colorLabel = numColors === 1 ? 'color' : 'colores';
          text += '- ' + technique + ' (' + numColors + ' ' + colorLabel + ')\n\n';
        });
        emailComment.textContent = text;
      }
    }

    function setCalculating(on) {
      calculating = on;
      productRoot.classList.toggle('is-calculating', on);
      quote.classList.toggle('is-calculating', on);
      if (loadingEl) loadingEl.hidden = !on;
      if (addBtn) addBtn.disabled = on;
      posBox.querySelectorAll('button').forEach(function (b) {
        b.disabled = on;
      });
      techBox.querySelectorAll('button').forEach(function (b) {
        b.disabled = on;
      });
    }

    function showError(msg) {
      if (!errorEl) return;
      if (!msg) {
        errorEl.hidden = true;
        errorEl.textContent = '';
        return;
      }
      errorEl.hidden = false;
      errorEl.textContent = msg;
    }

    function printDetailFor(item) {
      if (!item.tech) return 'Elige una técnica';
      const label = techniqueLabel(item.tech, labelMap);
      if ((item.maxColours || 1) > 1) {
        return label + ' · ' + item.colors + (item.colors === 1 ? ' color' : ' colores');
      }
      return label;
    }

    function extractPositionAmounts(apiData, selected, printTotalMarked) {
      const apiPositions = (apiData && apiData.printing_positions) || [];
      const amounts = selected.map(function (item, index) {
        const apiPos =
          apiPositions.find(function (p) {
            return p.position_id === item.pos.position_id;
          }) || apiPositions[index];
        if (!apiPos) return null;
        const raw =
          apiPos.cost ??
          apiPos.totalCost ??
          apiPos.price ??
          apiPos.amount ??
          (apiPos.printing_technique &&
            (apiPos.printing_technique.cost ??
              apiPos.printing_technique.totalCost ??
              apiPos.printing_technique.price)) ??
          null;
        if (raw == null || !Number.isFinite(Number(raw))) return null;
        return toNetPrice(raw);
      });

      if (amounts.length && amounts.every(function (a) {
        return a != null;
      })) {
        return amounts;
      }

      // Sin desglose por posición: una sola posición → todo el coste; varias → null (línea agrupada)
      if (selected.length === 1) return [printTotalMarked];
      return null;
    }

    function renderQuote(opts) {
      opts = opts || {};
      const units = getQty();
      if (units == null) {
        const setText = function (id, text) {
          const el = document.getElementById(id);
          if (el) el.textContent = text;
        };
        setText('clap-q-units', '—');
        setText('clap-q-product', '—');
        setText('clap-q-total', '—');
        setText('clap-q-each', '—');
        setText('clap-q-vat', '—');
        const color = getOption(getColorOptionName());
        setText('clap-q-variant', color || '');
        if (printsEl) {
          printsEl.innerHTML =
            '<div class="clap-quote__line"><div><div>Personalización</div>' +
            '<div class="clap-quote__sub">Indica cantidad por talla</div></div><b>—</b></div>';
        }
        if (addBtn) addBtn.disabled = true;
        return;
      }
      const productTotal = getProductTotalEuros(quote);
      const chosen = chosenList().filter(function (i) {
        return i.tech;
      });
      const incomplete = chosenList().some(function (i) {
        return !i.tech;
      });

      document.getElementById('clap-q-units').textContent = String(units);

      const sku = quote.dataset.productSku || '';
      const color = getOption(getColorOptionName());
      const breakdown = getSizeBreakdownLabel();
      const variantBits = [breakdown || sku, color].filter(Boolean);
      document.getElementById('clap-q-variant').textContent = variantBits.join(' · ');
      document.getElementById('clap-q-product').textContent = money(productTotal);

      printsEl.innerHTML = '';

      let printTotal = 0;

      if (incomplete) {
        const row = document.createElement('div');
        row.className = 'clap-quote__line';
        row.innerHTML =
          '<div><div>Personalización</div><div class="clap-quote__sub">Completa la técnica</div></div><b>—</b>';
        printsEl.appendChild(row);
      } else if (!chosen.length) {
        const row = document.createElement('div');
        row.className = 'clap-quote__line';
        row.innerHTML =
          '<div><div>Personalización</div><div class="clap-quote__sub">Sin personalización</div></div><b>0,00 €</b>';
        printsEl.appendChild(row);
        latestTotalCost = 0;
        latestPrintTotal = 0;
        latestApiData = { printing_positions: [] };
      } else if (opts.apiData && opts.apiData.totalCost !== undefined) {
        printTotal = toNetPrice(opts.apiData.totalCost);
        latestTotalCost = Number(opts.apiData.totalCost);
        latestPrintTotal = printTotal;
        latestApiData = opts.apiData;

        const amounts = extractPositionAmounts(opts.apiData, chosen, printTotal);
        if (amounts) {
          chosen.forEach(function (item, i) {
            const row = document.createElement('div');
            row.className = 'clap-quote__line';
            const info = document.createElement('div');
            const name = document.createElement('div');
            name.textContent = positionLabel(item.pos.position_id, positionMap);
            const sub = document.createElement('div');
            sub.className = 'clap-quote__sub';
            sub.textContent = printDetailFor(item);
            info.appendChild(name);
            info.appendChild(sub);
            const price = document.createElement('b');
            price.textContent = money(amounts[i]);
            row.appendChild(info);
            row.appendChild(price);
            printsEl.appendChild(row);
          });
        } else {
          // API sin coste por posición: listamos posiciones y un total de personalización
          chosen.forEach(function (item) {
            const row = document.createElement('div');
            row.className = 'clap-quote__line';
            const info = document.createElement('div');
            const name = document.createElement('div');
            name.textContent = positionLabel(item.pos.position_id, positionMap);
            const sub = document.createElement('div');
            sub.className = 'clap-quote__sub';
            sub.textContent = printDetailFor(item);
            info.appendChild(name);
            info.appendChild(sub);
            const price = document.createElement('b');
            price.textContent = '—';
            row.appendChild(info);
            row.appendChild(price);
            printsEl.appendChild(row);
          });
          const totalRow = document.createElement('div');
          totalRow.className = 'clap-quote__line';
          totalRow.innerHTML =
            '<div><div>Total personalización</div><div class="clap-quote__sub">' +
            chosen.length +
            ' posiciones</div></div>';
          const b = document.createElement('b');
          b.textContent = money(printTotal);
          totalRow.appendChild(b);
          printsEl.appendChild(totalRow);
        }
      } else if (opts.pending) {
        chosen.forEach(function (item) {
          const row = document.createElement('div');
          row.className = 'clap-quote__line';
          const info = document.createElement('div');
          const name = document.createElement('div');
          name.textContent = positionLabel(item.pos.position_id, positionMap);
          const sub = document.createElement('div');
          sub.className = 'clap-quote__sub';
          sub.textContent = printDetailFor(item);
          info.appendChild(name);
          info.appendChild(sub);
          const price = document.createElement('b');
          price.textContent = '…';
          row.appendChild(info);
          row.appendChild(price);
          printsEl.appendChild(row);
        });
        printTotal = latestPrintTotal;
      } else if (chosen.length && latestApiData && latestTotalCost != null) {
        // Reutilizar último cálculo conocido
        opts = { apiData: Object.assign({}, latestApiData, { totalCost: latestTotalCost }) };
        printTotal = toNetPrice(opts.apiData.totalCost);
        const amounts = extractPositionAmounts(opts.apiData, chosen, printTotal);
        if (amounts) {
          chosen.forEach(function (item, i) {
            const row = document.createElement('div');
            row.className = 'clap-quote__line';
            const info = document.createElement('div');
            const name = document.createElement('div');
            name.textContent = positionLabel(item.pos.position_id, positionMap);
            const sub = document.createElement('div');
            sub.className = 'clap-quote__sub';
            sub.textContent = printDetailFor(item);
            info.appendChild(name);
            info.appendChild(sub);
            const price = document.createElement('b');
            price.textContent = money(amounts[i]);
            row.appendChild(info);
            row.appendChild(price);
            printsEl.appendChild(row);
          });
        } else {
          chosen.forEach(function (item) {
            const row = document.createElement('div');
            row.className = 'clap-quote__line';
            const info = document.createElement('div');
            const name = document.createElement('div');
            name.textContent = positionLabel(item.pos.position_id, positionMap);
            const sub = document.createElement('div');
            sub.className = 'clap-quote__sub';
            sub.textContent = printDetailFor(item);
            info.appendChild(name);
            info.appendChild(sub);
            const price = document.createElement('b');
            price.textContent = '—';
            row.appendChild(info);
            row.appendChild(price);
            printsEl.appendChild(row);
          });
          const totalRow = document.createElement('div');
          totalRow.className = 'clap-quote__line';
          const info = document.createElement('div');
          info.innerHTML = '<div>Total personalización</div><div class="clap-quote__sub">' + chosen.length + ' posiciones</div>';
          const b = document.createElement('b');
          b.textContent = money(printTotal);
          totalRow.appendChild(info);
          totalRow.appendChild(b);
          printsEl.appendChild(totalRow);
        }
      } else {
        printTotal = 0;
        chosen.forEach(function (item) {
          const row = document.createElement('div');
          row.className = 'clap-quote__line';
          const info = document.createElement('div');
          const name = document.createElement('div');
          name.textContent = positionLabel(item.pos.position_id, positionMap);
          const sub = document.createElement('div');
          sub.className = 'clap-quote__sub';
          sub.textContent = printDetailFor(item);
          info.appendChild(name);
          info.appendChild(sub);
          const price = document.createElement('b');
          price.textContent = '—';
          row.appendChild(info);
          row.appendChild(price);
          printsEl.appendChild(row);
        });
      }

      const total = productTotal + (incomplete ? 0 : printTotal);
      document.getElementById('clap-q-total').textContent = money(total);
      document.getElementById('clap-q-each').textContent = money(total / units);
      document.getElementById('clap-q-vat').textContent = money(total * vat);

      const hasQty = units != null && units >= 1;
      const canAdd =
        hasQty && !incomplete && !calculating && (!chosen.length || latestTotalCost != null);
      if (addBtn) addBtn.disabled = !canAdd || calculating;
    }

    function scheduleCalculate() {
      syncSelectedJson();
      clearTimeout(debounceTimer);
      const units = getQty();
      const chosen = chosenList();
      const readyPositions = chosen.filter(function (i) {
        return i.tech;
      });
      const incomplete = chosen.some(function (i) {
        return !i.tech;
      });

      if (units == null) {
        setCalculating(false);
        renderQuote();
        return;
      }

      if (!readyPositions.length) {
        showError('');
        latestTotalCost = 0;
        latestPrintTotal = 0;
        latestApiData = { printing_positions: [] };
        setCalculating(false);
        renderQuote();
        return;
      }

      if (incomplete) {
        setCalculating(false);
        renderQuote();
        return;
      }

      // Skeleton desde el primer cambio (evita flicker de precios)
      setCalculating(true);
      debounceTimer = setTimeout(runCalculate, DEBOUNCE_MS);
    }

    function runCalculate() {
      const requestData = buildRequestData();
      if (!requestData.printing_positions.length) {
        setCalculating(false);
        renderQuote();
        return;
      }

      const token = ++calcToken;
      setCalculating(true);
      showError('');

      fetch(MIDDLEWARE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': MIDDLEWARE_API_KEY
        },
        body: JSON.stringify(requestData)
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          if (token !== calcToken) return;
          if (result.data && result.data.totalCost !== undefined) {
            renderQuote({ apiData: result.data });
            showError('');
          } else {
            latestTotalCost = null;
            latestPrintTotal = 0;
            latestApiData = null;
            showError(
              (result.data && (result.data.message || result.data.error)) ||
                'La API no devolvió un precio válido.'
            );
            renderQuote({ pending: false });
          }
        })
        .catch(function (err) {
          if (token !== calcToken) return;
          console.error('[clap] calculatePrice', err);
          latestTotalCost = null;
          latestPrintTotal = 0;
          latestApiData = null;
          showError('Hubo un error al calcular la personalización.');
          renderQuote();
        })
        .finally(function () {
          if (token === calcToken) setCalculating(false);
        });
    }

    async function addToCart() {
      try {
        showError('');
        const units = getQty();
        if (units == null) {
          showError(
            isSizeMatrixProduct()
              ? 'Indica la cantidad en al menos una talla.'
              : 'Indica una cantidad válida.'
          );
          return;
        }

        if (isSizeMatrixProduct() && !getSizeLines().length) {
          showError('Indica la cantidad en al menos una talla.');
          return;
        }
        if (!isSizeMatrixProduct() && !getVariantId(quote)) {
          showError('No se ha podido detectar la variante seleccionada.');
          return;
        }

        const chosen = chosenList().filter(function (i) {
          return i.tech;
        });

        addBtn.disabled = true;
        addBtn.textContent = 'Procesando…';

        const formData = new FormData();
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        if (!chosen.length) {
          appendProductLines(formData, 0, null);
        } else {
          if (latestTotalCost == null) {
            showError('Espera a que termine el cálculo del presupuesto.');
            addBtn.disabled = false;
            addBtn.textContent = 'Agregar al carrito';
            return;
          }

          const quoteRes = await fetch(QUOTE_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ totalCost: toQuoteBase(latestTotalCost) })
          });
          const quoteData = await quoteRes.json().catch(function () {
            return {};
          });
          const customizationVariantId = quoteData.variantId;
          if (!quoteRes.ok || !customizationVariantId) {
            console.error('[clap] quote', quoteRes.status, quoteData);
            showError('No se pudo crear la línea de personalización.');
            addBtn.disabled = false;
            addBtn.textContent = 'Agregar al carrito';
            return;
          }

          let detalles = '';
          const positions =
            (latestApiData && latestApiData.printing_positions) ||
            buildRequestData().printing_positions;
          positions.forEach(function (pos) {
            const tecnica = techniqueLabel(pos.printing_technique.name, labelMap);
            const colores = pos.printing_technique.colors;
            const posicion = positionLabel(pos.position_id, positionMap);
            detalles +=
              'Posición: ' +
              posicion +
              '\n- ' +
              tecnica +
              ' (' +
              colores +
              ' color' +
              (colores > 1 ? 'es' : '') +
              ')\n\n';
          });

          const shownPrice = toNetPrice(latestTotalCost).toFixed(2);
          const sizeBreakdown = getSizeBreakdownLabel();
          const personalizationProps = {
            Personalización: 'Sí',
            'Precio total personalización': shownPrice + ' €',
            'Personalización detallada': detalles.trim()
          };
          if (sizeBreakdown) {
            personalizationProps['Desglose tallas'] = sizeBreakdown;
          }

          let nextIdx = appendProductLines(formData, 0, personalizationProps);

          const fileInputs = document.querySelectorAll("input[type='file'][name^='properties']");
          let fileIndex = 1;
          fileInputs.forEach(function (input) {
            if (input.files && input.files.length) {
              for (let i = 0; i < input.files.length; i++) {
                formData.append('items[0][properties][Archivo ' + fileIndex + ']', input.files[i]);
                fileIndex++;
              }
            }
          });

          formData.append('items[' + nextIdx + '][id]', customizationVariantId);
          formData.append('items[' + nextIdx + '][quantity]', '1');
        }

        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart
              .getSectionsToRender()
              .map(function (section) {
                return section.id;
              })
              .join(',')
          );
          formData.append('sections_url', window.location.pathname);
        }

        const cartUrl =
          (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        const cartRes = await fetch(cartUrl, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript'
          },
          body: formData
        });
        const cartData = await cartRes.json().catch(function () {
          return null;
        });

        if (!cartRes.ok || !cartData || cartData.status) {
          console.error('[clap] cart/add', cartRes.status, cartData);
          showError(
            (cartData && (cartData.description || cartData.message)) ||
              'No se pudo añadir al carrito.'
          );
          return;
        }

        // El add sí funciona; el fallo era al pintar la UI (multi-item no trae `key`)
        await finishCartAdd(cartData);
      } catch (err) {
        console.error('[clap] addToCart', err);
        showError('No se pudo añadir al carrito.');
      } finally {
        addBtn.disabled = false;
        addBtn.textContent = 'Agregar al carrito';
        renderQuote(latestApiData ? { apiData: Object.assign({}, latestApiData, { totalCost: latestTotalCost }) } : {});
      }
    }

    function normalizeCartAddResponse(cartData) {
      if (!cartData) return cartData;
      if (cartData.key) return cartData;
      const first = cartData.items && cartData.items[0];
      if (!first) return cartData;
      return Object.assign({}, cartData, {
        key: first.key,
        id: first.id
      });
    }

    function isCartFeeItem(item) {
      if (!item) return false;
      const title = String(item.product_title || item.title || '');
      const handle = String(item.handle || '');
      if (handle === 'personalizacion') return true;
      if (title === 'Personalización' || title === 'Personalizacion') return true;
      const url = String(item.url || '');
      return url.indexOf('/products/personalizacion') !== -1;
    }

    function cartVisibleCount(cart) {
      if (!cart || !cart.items) return 0;
      return cart.items.reduce(function (sum, item) {
        return isCartFeeItem(item) ? sum : sum + (item.quantity || 0);
      }, 0);
    }

    function paintCartCountBubble(count) {
      const target = document.getElementById('cart-icon-bubble');
      if (!target) return;

      let bubble = target.querySelector('.cart-count-bubble');
      if (count <= 0) {
        if (bubble) bubble.remove();
        return;
      }

      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        target.appendChild(bubble);
      }

      // Un solo dígito visible (Liquid + JS no deben acumular spans)
      bubble.className = 'cart-count-bubble' + (count > 99 ? ' cart-count-bubble--lg' : '');
      bubble.innerHTML =
        '<span aria-hidden="true" data-clap-cart-count="1">' +
        String(count) +
        '</span>';
    }

    async function refreshCartIconBubble() {
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      const bubbleRes = await fetch(cartUrl + '?section_id=cart-icon-bubble');
      const bubbleDoc = new DOMParser().parseFromString(await bubbleRes.text(), 'text/html');
      const bubbleSection = bubbleDoc.querySelector('.shopify-section');
      const bubbleTarget = document.getElementById('cart-icon-bubble');
      if (bubbleSection && bubbleTarget) bubbleTarget.innerHTML = bubbleSection.innerHTML;

      try {
        const cart = await fetch('/cart.js').then(function (r) {
          return r.json();
        });
        if (typeof window.__clapPaintCartBubble === 'function') {
          window.__clapPaintCartBubble(cart);
        } else {
          paintCartCountBubble(cartVisibleCount(cart));
        }
      } catch (e) {
        /* noop */
      }
    }

    async function finishCartAdd(cartData) {
      const normalized = normalizeCartAddResponse(cartData);
      const cartEl =
        document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      try {
        if (cartEl && typeof cartEl.renderContents === 'function' && normalized.sections) {
          cartEl.renderContents(normalized);
          await refreshCartIconBubble();
          return;
        }
      } catch (err) {
        console.warn('[clap] renderContents falló, refresco manual', err);
      }

      try {
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';

        await refreshCartIconBubble();

        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          const drawerRes = await fetch(cartUrl + '?section_id=cart-drawer');
          const drawerDoc = new DOMParser().parseFromString(await drawerRes.text(), 'text/html');
          ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
            const target = document.querySelector(selector);
            const source = drawerDoc.querySelector(selector);
            if (target && source) target.replaceWith(source);
          });
          drawer.classList.remove('is-empty');
          if (typeof drawer.open === 'function') drawer.open();
          return;
        }

        const notification = document.querySelector('cart-notification');
        if (notification && typeof notification.open === 'function') {
          notification.open();
          return;
        }
      } catch (err2) {
        console.warn('[clap] refresh cart UI', err2);
      }

      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }

    addBtn.addEventListener('click', addToCart);

    document.addEventListener('clap:qty-change', function () {
      scheduleCalculate();
      if (!chosenList().length) renderQuote();
    });

    // Cambios de variantes / opciones (cantidad la gestiona clap-qty-*)
    document.addEventListener('change', function (event) {
      const t = event.target;
      if (!t || !t.matches) return;
      if (t.id === 'clap-qty-select' || t.id === 'clap-qty-custom') return;
      if (t.matches('input[name="quantity"]')) return;

      const isOption = t.matches('select[name^="options["], input[name^="options["]');
      if (!isOption) return;

      if (t.name && t.name.indexOf('Color') !== -1) {
        const code = COLOR_CODES[t.value];
        updatePositionImages(code);
      }

      const idInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"], .product-variant-id');
      if (idInput && idInput.value) quote.dataset.variantId = idInput.value;

      scheduleCalculate();
      if (!chosenList().length) renderQuote();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        try {
          const variant = event && event.data && event.data.variant;
          if (variant) {
            if (variant.id) quote.dataset.variantId = String(variant.id);
            if (variant.price != null) quote.dataset.unitPrice = String(variant.price);
            if (variant.sku) quote.dataset.productSku = variant.sku;
          }
        } catch (e) {}
        scheduleCalculate();
        if (!chosenList().length) renderQuote();
      });
    }

    renderPositions();
    renderTech();
    renderQuote();
    markClapPdpReady(productRoot);
    window.validatePositionsAndTechniques = function () {
      const checked = chosenList();
      const missing = checked.filter(function (i) {
        return !i.tech;
      });
      if (missing.length) {
        alert(
          missing
            .map(function (i) {
              return 'Para la posición ' + i.pos.position_id + ' debe seleccionarse una técnica.';
            })
            .join('\n')
        );
        return false;
      }
      return true;
    };
  });
})();
